// extracted by mini-css-extract-plugin
export var footer = "_rv-0";
export var inherit = "_rv-1";
export var input = "_rv-2";
export var modalContent = "_rv-3";
export var quillEditor = "_rv-4";
export var subtitle = "_rv-5";